import { useRefund } from "@/hooks/useRefundPartial";
import { Button, Modal } from "barte-design-system";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";


interface ConfirmeModalProps {
    setReload: React.Dispatch<React.SetStateAction<number>>;
    setOpenResponseModal: React.Dispatch<React.SetStateAction<boolean>>;
    setResponseModal: React.Dispatch<React.SetStateAction<any>>;
    openModal: boolean;
    setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
    amount: number;
    onRefundSuccess: (id: string) => Promise<void>;
}

export const ConfirmeModal = ({ setReload, setOpenResponseModal, setResponseModal, openModal, setOpenModal, amount, onRefundSuccess }: ConfirmeModalProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const { solicitationRefund } = useRefund();
    const [loading, setLoading] = useState(false)

    const { id } = useParams();
    useEffect(() => {
        if (openModal) {
            setIsOpen(true);
        } else {
            setIsOpen(false);
        }
    }, [openModal]);

    const handleClose = () => {
        setIsOpen(false);
        setOpenModal(false)
    };

    async function getResponse() {
        setLoading(true)

        try {
            const data = { value: Number(amount) }
            const response = await solicitationRefund(id, data)
            setResponseModal(response)
            setOpenResponseModal(true)
            setOpenModal(false)
            if (onRefundSuccess) {
                await onRefundSuccess(id);
            }
        } catch (error: any) {
            console.error("Erro ao solicitar estorno:", error);

            let errorData;
            if (Array.isArray(error?.response?.data) && error.response.data[0]?.errors?.[0]) {
                errorData = error.response.data[0].errors[0];
            } else if (error?.response?.data?.errors?.[0]) {
                errorData = error.response.data.errors[0];
            } else {
                errorData = {
                    title: "Erro ao processar estorno",
                    description: error?.message || "Ocorreu um erro ao processar a solicitação de estorno. Tente novamente."
                };
            }

            setResponseModal({ ...errorData, error: true });
            setOpenResponseModal(true);
            setOpenModal(false);
        }
        setLoading(false)
    }

    const formattedAmount = Number(amount) > 0 ? Number(amount).toFixed(2) : "0.00";

    return (
        <Modal
            isOpen={isOpen}
            title="Deseja estornar essa cobrança?"
            onClose={handleClose}
            footer={{
                primaryButton: {
                    children: "Estornar",
                    onClick: getResponse,
                    loading,
                },
                secondaryButton: {
                    children: "Cancelar",
                    onClick: handleClose,
                    variant: "outline",
                },
            }}
        >
            <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
                <img width="24" height="24" src="/images/icons/ExclamationCircle.svg" alt="" />
                <p style={{ fontSize: "0.875rem" }}>
                    {`Será estornado o valor de R$ ${formattedAmount} e essa ação não poderá ser desfeita.`}
                </p>
            </div>
        </Modal>
    );
};
